export const nonBackground = (): string => {
  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<circle cx="12" cy="12" r="11" fill="white"/>
<line x1="4.79289" y1="18.9355" x2="18.935" y2="4.79334" stroke="#E22144" stroke-width="2"/>
</svg>
`
  const blob = new Blob([svgString], { type: 'image/svg+xml' })
  const url = URL.createObjectURL(blob)

  return url
}
